import { createContext, useContext, type ReactNode } from "react";

import type { Me } from "../api/types";

const MeContext = createContext<Me | null>(null);

export function MeProvider({ me, children }: { me: Me; children: ReactNode }) {
  return <MeContext.Provider value={me}>{children}</MeContext.Provider>;
}

/** The signed-in user (GET /api/me), available everywhere under the app shell. */
export function useCurrentUser(): Me {
  const me = useContext(MeContext);
  if (!me) throw new Error("useCurrentUser outside of <MeProvider>");
  return me;
}
